import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';

const optionsLong: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

const optionsShort: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: '2-digit',
};

export const formatNgbDate = (
  ngbDate: NgbDateStruct | null,
  options: Intl.DateTimeFormatOptions,
  locales: Intl.LocalesArgument = 'en-US'
): string | null => {
  const date = ngbDateToDate(ngbDate);

  if (!date) {
    return null;
  }

  return date.toLocaleDateString(locales, options);
};

type formatDateOptions = {
  removeYearIfCurrent?: boolean;
};

export const formatDateLong = (
  date: NgbDateStruct | null,
  options: formatDateOptions = {}
): string | null => {
  const formatting = { ...optionsLong };

  if (options.removeYearIfCurrent && date?.year === new Date().getFullYear()) {
    formatting.year = undefined;
  }

  return formatNgbDate(date, formatting);
};

export const formatNgbDateShort = (
  date: NgbDateStruct | null
): string | null => {
  return formatNgbDate(date, optionsShort);
};

export const ngbDateToDate = (date: NgbDateStruct | null): Date | null => {
  if (!date) {
    return null;
  }

  return new Date(date.year, date.month - 1, date.day);
};
